import React from 'react'
import { Timeline } from '@node-space/ui-components'
import { PaymentsResponse } from 'types/payments'
import { useUpdateTimeline } from '../../../hooks/useUpdateTimeline'

interface PaymentTimelineProps {
  transaction: PaymentsResponse
}

export const PaymentTimeline = ({ transaction }: PaymentTimelineProps) => {
  const values = useUpdateTimeline(transaction)

  return <Timeline items={values} />
}
